// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-selector-menu {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.app-selector-menu__button {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background: #F5EFE7;
  outline: 1px solid #F5EFE7;
}
.app-selector-menu__button:hover {
  background: #fff9f2;
  outline: 1px solid #213555;
}

.app-selector-menu__button__content {
  position: relative;
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-self: stretch;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  border-right: 0px;
}
.app-selector-menu__button__content__selected-item-title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  color: #213555;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/AppSelectorMenu/AppSelectorMenu.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EAEA,mBCTa;EDUb,0BAAA;AAHF;AAKE;EACE,mBCZc;EDad,0BAAA;AAHJ;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EAEA,8BAAA;EACA,mBAAA;EAEA,mBAAA;EACA,iBAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EAEA,cC/CS;EDgDT,eAAA;AARJ","sourcesContent":["@use \"../../utils/themeConstants\";\r\n\r\n.app-selector-menu {\r\n  position: relative;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.app-selector-menu__button {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n\r\n  background: themeConstants.$color-bright;\r\n  outline: 1px solid themeConstants.$color-bright;\r\n\r\n  &:hover {\r\n    background: themeConstants.$color-brightest;\r\n    outline: 1px solid themeConstants.$color-dark;\r\n  }\r\n}\r\n\r\n$searchFieldHeight: 54px;\r\n.app-selector-menu__button__content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-self: stretch;\r\n  justify-self: stretch;\r\n\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  border-radius: 10px;\r\n  border-right: 0px;\r\n\r\n  &__selected-item-title {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    gap: 12px;\r\n  \r\n    color: themeConstants.$color-dark;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
